import { render, staticRenderFns } from "./maintenancePlanDetail.vue?vue&type=template&id=afbf59f4"
import script from "./maintenancePlanDetail.vue?vue&type=script&lang=js"
export * from "./maintenancePlanDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports